import React, {Component} from 'react';
import {connect} from 'react-redux'

import bindAll from 'lodash.bindall';
import RecordComponent from '../components/badge/record.jsx';
import {getBadgeListRequest} from "../service/reason";


import {FILE_URL} from "../util/constants";
import defaultImg from '../img/bee.png';

class RecordContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'handleScroll',
            'handleImageErrored'
        ]);
        this.state = {
            recordList: [],
            isBottom: false,
            showPrompt:false,
            item:{}
        }
    }

    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll, true);

        getBadgeListRequest(this.props.banji_code, '0', (data) => {
            console.log(data)
            if (data.ret == '1') {

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                }
                this.setState({
                    recordList: list
                });

            } else {

            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleImageErrored(index){
        console.log('加载图片出错')
        var list = this.state.recordList;
        list[index].student_pic = defaultImg;

        this.setState({
            recordList:list
        });
    }

    handleScroll(event) {

        const clientHeight = event.target.clientHeight
        const scrollHeight = event.target.scrollHeight
        const scrollTop = event.target.scrollTop

        var plusHeight = clientHeight + parseInt(scrollTop);
        var isBottom = (plusHeight === scrollHeight)

        if (isBottom) {
            console.log('加载更多')
        } else {
            console.log('没到达底部')
        }

        if (plusHeight == scrollHeight) {


            getBadgeListRequest(this.props.banji_code, this.state.recordList.length, (data) => {
                console.log(data)
                if (data.ret == '1') {
                    this.setState({
                        recordList: this.state.recordList.concat(data.data)
                    });
                } else {

                }
            });

        }
    }


    handleCancel() {
        this.props.closeSelf();
    }


    render() {

        return (
            <div>
                <RecordComponent
                    recordList={this.state.recordList}
                    onRequestClose={this.props.closeRecord}
                    handleImageErrored={this.handleImageErrored}
                />

            </div>

        )
    }


}

RecordContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecordContainer);
